export const getSelectedChoices = (formState) => {
  return formState.filter(choice => choice.checked);
};